import type { ReactElement } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/atoms/button';
import { ErrorState } from '@/components/molecules/error-state';

export function ForbiddenScreen(): ReactElement {
  return (
    <ErrorState
      title="You don't have access to this page."
      description="If you think this is a mistake, sign out and back in. Otherwise, head back to your dashboard."
      action={
        <Link to="/">
          <Button size="lg" fullWidth>
            Back to dashboard
          </Button>
        </Link>
      }
    />
  );
}
